import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initialState";
import { fetchBillingHistory } from "./billingHistory.thunk";

const billingHistorySlice = createSlice({
  name: "billingHistory",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBillingHistory.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchBillingHistory.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.meta.aborted
          ? null
          : "Failed to fetch billing history";
      })
      .addCase(fetchBillingHistory.fulfilled, (state, action) => {
        const { lastInvoiceId } = action.meta.arg;
        const { data, hasMore } = action.payload;
        const records = lastInvoiceId ? [...state.data, ...data] : data;

        state.isLoading = false;
        state.error = null;
        state.data = records;
        state.total = records.length;
        state.hasMore = hasMore;
      });
  },
});

export default billingHistorySlice.reducer;
